import React from "react";
import styled, { css } from "styled-components";
import { Z } from "@ui/styles/zIndex";

export const toolbarStyle = css`
	position: fixed;
	display: flex;
	justify-content: center;
	z-index: ${Z.toolbar};
	left: 0;
	bottom: 0;
	right: 0;
	padding: 22px 100px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	box-shadow: 0 2px 54px 0 rgba(0, 0, 0, 0.12);
	background-color: ${({ theme }) => theme.colors.white};

	@media (max-width: 900px) {
		padding: 22px 10px;
	}
`;

export const Toolbar: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...htmlProps }) => {
	return <ToolbarContainer {...htmlProps} />;
};

const ToolbarContainer = styled.div`
	${toolbarStyle};
`;
